import React from 'react';

// 共通のスタイルを適用するためのラッパーコンポーネント
interface IconWrapperProps {
  className?: string;
  children: React.ReactNode;
}

/**
 * アイコンをラップするためのコンポーネント
 * スタイルを適用するための共通コンポーネント
 */
export const IconWrapper: React.FC<IconWrapperProps> = ({ className, children }) => {
  return (
    <span className={className} style={{ display: 'inline-flex', alignItems: 'center' }}>
      {children}
    </span>
  );
};

// 個別のアイコンコンポーネント
// 問題になっているReact.createElementを使わずに、SVGを直接レンダリング
export const SearchIcon: React.FC<{ className?: string }> = ({ className }) => (
  <IconWrapper className={className}>
    <svg
      stroke="currentColor"
      fill="none"
      strokeWidth="2"
      viewBox="0 0 24 24"
      strokeLinecap="round"
      strokeLinejoin="round"
      height="1em"
      width="1em"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="11" cy="11" r="8"></circle>
      <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
    </svg>
  </IconWrapper>
);

export const StarIcon: React.FC<{ className?: string }> = ({ className }) => (
  <IconWrapper className={className}>
    <svg
      stroke="currentColor"
      fill="none"
      strokeWidth="2"
      viewBox="0 0 24 24"
      strokeLinecap="round"
      strokeLinejoin="round"
      height="1em"
      width="1em"
      xmlns="http://www.w3.org/2000/svg"
    >
      <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>
    </svg>
  </IconWrapper>
);

export const ClockIcon: React.FC<{ className?: string }> = ({ className }) => (
  <IconWrapper className={className}>
    <svg
      stroke="currentColor"
      fill="none"
      strokeWidth="2"
      viewBox="0 0 24 24"
      strokeLinecap="round"
      strokeLinejoin="round"
      height="1em"
      width="1em"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="12" cy="12" r="10"></circle>
      <polyline points="12 6 12 12 16 14"></polyline>
    </svg>
  </IconWrapper>
);

export default IconWrapper;
